<app-pageheader [Parent]="this">
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="valet/surveys/searches"
  [AllowEdit]="true" EditUrl="/valet/surveys/:id" [UseQueryParamStates]="true">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-date-filter DateSearchProperty="ReceivedAt"></div>
    <div app-valetstations-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>
